import AttorneyBioTemplate from '@/components/AttorneyBioTemplate';
import { attorneys } from '@/data/attorneys';

export default function LizaGrossPage() {
  return <AttorneyBioTemplate attorney={attorneys['liza-gross-esq']} />;
}
